// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { WaitlistSignup } = initSchema(schema);

export {
  WaitlistSignup
};